import type { HostEnvironment } from '@/shared/tools/hostEnvironment'
import { EnvironmentBannerBar } from './styled-components'

interface EnvironmentBannerProps {
  environment: HostEnvironment | null
  hidden?: boolean
}

const EnvironmentBanner = ({ environment, hidden = false }: EnvironmentBannerProps) => {
  if (hidden || !environment) return null

  return <EnvironmentBannerBar role='status'>{environment}</EnvironmentBannerBar>
}

export default EnvironmentBanner
